import { object, string, date, ref } from 'yup';
import { ACTIVITY_LOG_FORM_FEILDS } from 'features/wells/overview/activityLog/helpers/activityLog.constants';
import moment from 'moment';

//Commented Rich text editor validations. Need to look into them furhter
export const getActivityLogFormSchema = () =>
  object().shape({
    [ACTIVITY_LOG_FORM_FEILDS.ACTIVITY_NAME]: string()
      .required('File name is required')
      .nullable(),
    // [ACTIVITY_LOG_FORM_FEILDS.DESCRIPTION]: mixed()
    //     .test('is-editor-state', 'Invalid editor value', (value) =>
    //         EditorState.isEditorState(value),
    //     )
    //     .test('has-text', 'Description is required', (value) => {
    //         const content = value.getCurrentContent();
    //         const text = content.getPlainText('').trim();
    //         return text.length > 0;
    //     }),
    [ACTIVITY_LOG_FORM_FEILDS.START_DATE]: date()
      .nullable()
      .typeError('Invalid date format')
      .required('Start date is required'),
    [ACTIVITY_LOG_FORM_FEILDS.END_DATE]: date()
      .nullable()
      .typeError('Invalid date format')
      .required('End date is required')
      .min(
        ref(ACTIVITY_LOG_FORM_FEILDS.START_DATE),
        'End date cannot be before start date',
      ),
    [ACTIVITY_LOG_FORM_FEILDS.STATUS]: string().required(
      'Please select a Status',
    ),
    [ACTIVITY_LOG_FORM_FEILDS.RESPONSIBLE]: string().required(
      'Please select a Responsible User',
    ),
    // [ACTIVITY_LOG_FORM_FEILDS.COMMENT]: mixed()
    //     .test('is-editor-state', 'Invalid editor value', (value) =>
    //         EditorState.isEditorState(value),
    //     )
    //     .test('has-text', 'Comment is required', (value) => {
    //         const content = value.getCurrentContent();
    //         const text = content.getPlainText('').trim();
    //         return text.length > 0;
    //     }),
    // [ACTIVITY_LOG_FORM_FEILDS.MITIGATION_SOLUTIONS]: mixed()
    //     .test('is-editor-state', 'Invalid editor value', (value) =>
    //         EditorState.isEditorState(value),
    //     )
    //     .test('has-text', 'Mitigation solutions are required', (value) => {
    //         const content = value.getCurrentContent();
    //         const text = content.getPlainText('').trim();
    //         return text.length > 0;
    //     }),
  });

export const isMomentObject = (date) => moment.isMoment(date);
